export default function MarketplaceTravelerSummary({
  traveler,
  reputation,
  reviewLabel,
  onOpenReviews,
  children,
}) {
  const name = traveler?.display_name || "Traveler";

  return (
    <>
      <div className="marketplace-traveler">
        {traveler?.photoUrl ? (
          <img src={traveler.photoUrl} alt="" />
        ) : (
          <span className="marketplace-traveler-avatar" aria-hidden="true">
            {name.trim().slice(0, 1).toUpperCase()}
          </span>
        )}
        <div>
          <span className="marketplace-traveler-label">Traveler / runner</span>
          {traveler?.is_public && traveler.public_profile_id ? (
            <a href={`/p/${traveler.public_profile_id}`}>{name}</a>
          ) : (
            <strong>{name}</strong>
          )}
          {traveler?.photoError && (
            <small>Profile photo could not be loaded.</small>
          )}
        </div>
      </div>
      {children}
      <p className="reputation-summary">{reputation}</p>
      {traveler?.role === "traveler" && traveler.verified && (
        <div className="traveler-review">
          <span>SabayBuy profile/account reviewed</span>
          <small>Not identity or government-ID verified.</small>
        </div>
      )}
      {onOpenReviews && (
        <button
          type="button"
          className="secondary review-profile-link"
          onClick={onOpenReviews}
        >
          {reviewLabel}
        </button>
      )}
    </>
  );
}
